import Step from './src/step.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToStep: SFCWithInstall<typeof Step> = withInstall(Step);

export * from './src/instance';
